module.exports = __webpack_public_path__ + "static/bg-intro-3b1586f1e823be4108e4ea43ac7037c9.jpg";